import { UIEventHandler, useCallback, useRef } from "react";

type Props = {
  handleChange: (value: string, shouldSave?: boolean) => void;
  loadMore: () => void;
  hasMore: boolean;
};

export const useTagInputView = ({ handleChange, loadMore, hasMore }: Props) => {
  const wrapRef = useRef<HTMLDivElement | null>(null);

  const handleOptionChange = (
    event: React.SyntheticEvent,
    newValue: string | null,
  ) => {
    if (newValue) {
      handleChange(newValue, true);
    }
  };

  const handleInputChange = (
    event: React.SyntheticEvent,
    newInputValue: string,
  ) => {
    if (event.type === "change") {
      handleChange(newInputValue, false);
    }
  };
  const handleScroll: UIEventHandler<HTMLUListElement> = useCallback(
    (event) => {
      const target = event.currentTarget;
      if (target.scrollHeight - target.scrollTop - 1 <= target.clientHeight) {
        if (hasMore) {
          loadMore();
        }
      }
    },
    [hasMore, loadMore],
  );

  return {
    wrapRef,
    handleOptionChange,
    handleInputChange,
    handleScroll,
  };
};
